import React from 'react';

import QuotaCategorySoftys  from 'components/Tvendo/Sale/QuotaBPartner/Softys/QuotaCategory/List.js';

export default function () {
  return <QuotaCategorySoftys  />;
}